import { RadioFieldOption } from "@kaltura/mediaspace-shared-ui";

// Form fields types available in the invite modal.
export enum FieldType {
    RADIO = "radio",
    TEXT = "text",
    EMAIL_AUTOCOMPLETE = "email_autocomplete",
}

// Represents the different roles a user can be invited as.
export enum InvitationType {
    VIEWER = "viewer",
    MODERATOR = "moderator",
    SPEAKER = "speaker",
}

// Base field properties shared by all field types
interface BaseField {
    label: string;
    id: string;
    required?: boolean;
    disabled?: boolean;
}

// Text field type
export interface TextField extends BaseField {
    type: FieldType.TEXT;
}

// Radio field type with required options
export interface RadioField extends BaseField {
    type: FieldType.RADIO;
    options: RadioFieldOption[]; // Now required for radio fields
}

// Email autocomplete field
export interface EmailAutocompleteField extends BaseField {
    type: FieldType.EMAIL_AUTOCOMPLETE;
    autocompleteUrl: string;
    onUserSelected?: (user: UserData) => void;
    restrictedDomains?: string[]; // List of restricted email domains
}

// Union type of all field types
export type Field = TextField | RadioField | EmailAutocompleteField;

// Represents a user details
export type UserData = {
    email: string;
    firstName: string;
    lastName: string;
    id: string; // Optional, for existing users the user ID
};
